<div class="flex flex-col items-center">
    <h1>Student Application</h1>
    <div>Deadline: {{ endDateDisplay }}</div>
    @if (pastDeadline === false || deadlineException === true) {
    <div class="max-w-[1100px]">
        <div class="flex flex-wrap gap-[12px] text-xs">
            <span [ngClass]="{
                active: currentPage === 0,
                navigable: currentPage > 0
            }" (click)="setPageNumber(0)">Instructions</span>

            <span [ngClass]="{
                    active: currentPage === 1,
                    inactive: highestPage < 1 || !instructionsRead,
                    navigable:
                        currentPage !== 1 &&
                        highestPage >= 1 &&
                        instructionsRead
                }" (click)="setPageNumber(1)">Student Info</span>

            <span [ngClass]="{
                    active: currentPage === 2,
                    inactive: highestPage < 2 || !instructionsRead,
                    navigable:
                        currentPage !== 2 &&
                        highestPage >= 2 &&
                        instructionsRead
                }" (click)="setPageNumber(2)">Financial Info</span>

            <span [ngClass]="{
                    active: currentPage === 3,
                    inactive: highestPage < 3 || !instructionsRead,
                    navigable:
                        currentPage !== 3 &&
                        highestPage >= 3 &&
                        instructionsRead
                }" (click)="setPageNumber(3)">Family Info</span>

            <span [ngClass]="{
                    active: currentPage === 4,
                    inactive: highestPage < 4 || !instructionsRead,
                    navigable:
                        currentPage !== 4 &&
                        highestPage >= 4 &&
                        instructionsRead
                }" (click)="setPageNumber(4)">College/Experience</span>

            <span [ngClass]="{
                    active: currentPage === 5,
                    inactive: highestPage < 5 || !instructionsRead,
                    navigable:
                        currentPage !== 5 &&
                        highestPage >= 5 &&
                        instructionsRead
                }" (click)="setPageNumber(5)">Essay</span>

            <span [ngClass]="{
                    active: currentPage === 6,
                    inactive: highestPage < 6 || !instructionsRead,
                    navigable:
                        currentPage !== 6 &&
                        highestPage >= 6 &&
                        instructionsRead
                }" (click)="setPageNumber(6)">Scholarship Selection</span>

            <span [ngClass]="{
                    active: currentPage === 7,
                    inactive: highestPage < 7 || !instructionsRead,
                    navigable:
                        currentPage !== 7 &&
                        highestPage >= 7 &&
                        instructionsRead
                }" (click)="setPageNumber(7)">Signature</span>

            <span class="inactive">Submitted Application</span>
        </div>
        <mat-divider></mat-divider>
    </div>
    }

    @if (loading === true) {
    <mat-spinner class="my-[20px]"></mat-spinner>
    }
    @else {
    <!-- Instructions -->
    @if (currentPage === 0) {
    <app-instructions [instructionsRead]="instructionsRead" [settings]="settings" [deadlineException]="deadlineException" [user]="user" (action)="handleInstructionsAction($event)"></app-instructions>
    }
    <!-- Student Info -->
    <div [hidden]="currentPage !== 1">
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" dynamicHeight class="my-[20px]">
            <mat-tab label="Student">
                <form [formGroup]="studentForm" (ngSubmit)="submitStudent(studentForm)">
                    <div class="flex flex-col items-center p-[30px]">
                        <div class="flex flex-wrap justify-between gap-[20px] w-full text-sm">
                            <div>
                                <div class="inactive">First Name</div>
                                <div class="active">
                                    {{ application.StudentInfo.FirstName }}
                                </div>
                            </div>
                            <div>
                                <div class="inactive">Middle Name</div>
                                <div class="active">
                                    {{ application.StudentInfo.MiddleName }}
                                </div>
                            </div>
                            <div>
                                <div class="inactive">Last Name</div>
                                <div class="active">
                                    {{ application.StudentInfo.LastName }}
                                </div>
                            </div>
                            <div>
                                <div class="inactive">Student ID</div>
                                <div class="active">
                                    {{ application.StudentInfo.StudentID }}
                                </div>
                            </div>
                            <div>
                                <div class="inactive">School</div>
                                <div class="active">
                                    {{ application.StudentInfo.School }}
                                </div>
                            </div>
                        </div>
                        <mat-divider class="w-full my-[10px]"></mat-divider>
                        <div class="flex flex-wrap justify-between gap-[20px] w-full text-sm">
                            <div>
                                <div class="inactive">Weighted GPA</div>
                                <div class="active">
                                    {{ application.StudentInfo.Gpa }}
                                </div>
                            </div>
                            <div>
                                <div class="inactive">Best Math SAT</div>
                                <div class="active">
                                    {{ application.StudentInfo.MathSat }}
                                </div>
                            </div>
                            <div>
                                <div class="inactive">Best Verbal SAT</div>
                                <div class="active">
                                    {{ application.StudentInfo.ReadingSat }}
                                </div>
                            </div>
                            <div>
                                <div class="inactive">Best CLT</div>
                                <div class="active">
                                    {{ application.StudentInfo.Clt }}
                                </div>
                            </div>
                            <div>
                                <div class="inactive">Best ACT</div>
                                <div class="active">
                                    {{ application.StudentInfo.Act }}
                                </div>
                            </div>
                        </div>
                        <mat-divider class="w-full my-[10px]"></mat-divider>
                        <div class="flex flex-wrap justify-between gap-[20px] w-full text-sm">
                            <div>
                                <div class="inactive">
                                    Passed Alg1/Geo EOC (or Concordant)
                                </div>
                                <div class="active">
                                    {{ application.StudentInfo.PassedAlgEoc }}
                                </div>
                            </div>
                            <div>
                                <div class="inactive">
                                    Passed FSA Reading (or Concordant)
                                </div>
                                <div class="active">
                                    {{
                                    application.StudentInfo.PassedFsaReading
                                    }}
                                </div>
                            </div>
                            <div>
                                <div class="inactive">
                                    Community Service Hours
                                </div>
                                <div class="active">
                                    {{
                                    application.StudentInfo.CommServiceHours
                                    }}
                                </div>
                            </div>
                            <div>
                                <div class="inactive">Paid Work Hours</div>
                                <div class="active">
                                    {{ application.StudentInfo.WorkHours }}
                                </div>
                            </div>
                        </div>
                        <mat-divider class="w-full my-[10px]"></mat-divider>
                        <div class="self-start">
                            <div class="flex flex-wrap items-start gap-x-[30px]">
                                <mat-form-field appearance="outline" class="w-[300px]">
                                    <mat-label>Mailing Address</mat-label>
                                    <input matInput formControlName="Address" required maxlength="41" />
                                    @if (studentForm.get('Address').hasError('required')) {
                                    <mat-error>response required</mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="w-[200px]">
                                    <mat-label>Apt #</mat-label>
                                    <input matInput formControlName="Apt" maxlength="10" />
                                </mat-form-field>
                            </div>
                            <div class="flex flex-wrap items-start gap-x-[30px]">
                                <mat-form-field appearance="outline" class="w-[300px]">
                                    <mat-label>City</mat-label>
                                    <input matInput formControlName="City" required maxlength="18" />
                                    @if (studentForm.get('City').hasError('required')) {
                                    <mat-error>response required</mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="w-[200px]">
                                    <mat-label>State</mat-label>
                                    <mat-select matInput formControlName="State">
                                        <mat-option>Select...</mat-option>
                                        <mat-option value="FL">Florida</mat-option>
                                        <mat-divider></mat-divider>
                                        @for (state of allStates; track state.Name) {
                                        <mat-option [value]="state.Abbreviation">{{ state.Name }}</mat-option>
                                        }
                                    </mat-select>
                                    @if (studentForm.get('State').hasError('required')) {
                                    <mat-error>response required</mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="w-[200px]">
                                    <mat-label>Zip</mat-label>
                                    <input matInput formControlName="Zip" />
                                    @if (studentForm.get('Zip').hasError('required')) {
                                    <mat-error>response required</mat-error>
                                    }
                                    @if (studentForm.get('Zip').hasError('zipCode')) {
                                    <mat-error>invalid zipcode</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            <div class="flex flex-wrap items-start gap-x-[30px]">
                                <mat-form-field appearance="outline" class="w-[200px]">
                                    <mat-label>Phone</mat-label>
                                    <input matInput formControlName="Phone" required maxlength="10" />
                                    @if (studentForm.get('Phone').hasError('required')) {
                                    <mat-error>response required</mat-error>
                                    }
                                    @if (studentForm.get('Phone').hasError('invalidPhone')) {
                                    <mat-error>invalid phone #</mat-error>
                                    }
                                </mat-form-field>
                                <div>
                                    <div class="inactive">Birth Date:</div>
                                    <div class="active">
                                        {{ application.StudentInfo.BirthDate }}
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-wrap items-start gap-x-[30px]">
                                <mat-form-field appearance="outline" class="w-[351px]">
                                    <mat-label>Personal Email</mat-label>
                                    <input matInput formControlName="PersonalEmail" required maxlength="100" />
                                    <mat-hint>use a personal email address that you
                                        check regularly</mat-hint>
                                    @if (studentForm.get('PersonalEmail').hasError('required')) {
                                    <mat-error>response required</mat-error>
                                    }
                                    @if (studentForm.get('PersonalEmail').hasError('email')) {
                                    <mat-error>invalid email</mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="w-[351px] mt-[10px]">
                                    <mat-label>School Email</mat-label>
                                    <input matInput formControlName="SchoolEmail" required maxlength="100" />
                                    @if (studentForm.get('SchoolEmail').hasError('required')) {
                                    <mat-error>response required</mat-error>
                                    }
                                    @if (studentForm.get('SchoolEmail').hasError('email')) {
                                    <mat-error>invalid email</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        </div>

                        @if (formSubmitted === true && studentForm.valid === false) {
                        <div class="summary my-[20px]">
                            <div>
                                Form is not complete or has invalid responses
                            </div>
                        </div>
                        }

                        <div class="flex flex-wrap justify-around gap-[5px] w-full mt-[30px]">
                            <button mat-raised-button type="button" (click)="focusUpdate()">
                                Fix Incorrect Info
                            </button>
                            <button mat-icon-button type="button" (click)="openStudentDialog()" matTooltip="Show info message for Student Info section">
                                <mat-icon [class.highlighted]="highlighted">info_outline</mat-icon>
                            </button>
                            @if (highestPage > 1) {
                            <button mat-raised-button type="button" (click)="setPageNumber(2)">
                                Next Section
                            </button>
                            }
                            <button mat-raised-button type="submit">
                                Save & Go To Next Section
                            </button>
                        </div>
                    </div>
                </form>
            </mat-tab>
            <mat-tab label="Transcript">
                <div class="flex flex-col items-center p-[30px]">
                    <h4>Courses - Completed</h4>
                    <div [ngClass]="{ smallScreenScrollCourses: smallScreen }">
                        <table class="courses">
                            <tr>
                                <th>School Year</th>
                                <th>District</th>
                                <th>School</th>
                                <th>Grade Level</th>
                                <th>Term</th>
                                <th>Course#</th>
                                <th>Course</th>
                                <th>Subject</th>
                                <th>Flag</th>
                                <th>Final Grade</th>
                                <th>Attempted</th>
                                <th>Earned</th>
                            </tr>
                            @for (c of application?.StudentInfo?.CompletedCourses; track c.Id) {
                            <tr>
                                <td>{{ c.SchoolYear }}</td>
                                <td>{{ c.District }}</td>
                                <td>{{ c.SchoolInfo }}</td>
                                <td>{{ c.GradeLevel }}</td>
                                <td>{{ c.Term }}</td>
                                <td>{{ c.CourseNumber }}</td>
                                <td>{{ c.CourseName }}</td>
                                <td>{{ c.Subject }}</td>
                                <td>{{ c.Flag }}</td>
                                <td>{{ c.FinalGrade }}</td>
                                <td>{{ c.CreditAttempted }}</td>
                                <td>{{ c.CreditEarned }}</td>
                            </tr>
                            }
                        </table>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="Current Courses">
                <div class="flex flex-col items-center p-[30px]">
                    <h4>Courses - In Progress</h4>
                    <div [ngClass]="{ smallScreenScrollCourses: smallScreen }">
                        <table class="courses">
                            <tr>
                                <th>School Year</th>
                                <th>District</th>
                                <th>School</th>
                                <th>Grade Level</th>
                                <th>Term</th>
                                <th>Course#</th>
                                <th>Course</th>
                                <th>Subject</th>
                            </tr>
                            @for (c of application?.StudentInfo?.IncompleteCourses; track c.Id) {
                            <tr>
                                <td>{{ c.SchoolYear }}</td>
                                <td>{{ c.District }}</td>
                                <td>{{ c.SchoolInfo }}</td>
                                <td>{{ c.GradeLevel }}</td>
                                <td>{{ c.Term }}</td>
                                <td>{{ c.CourseNumber }}</td>
                                <td>{{ c.CourseName }}</td>
                                <td>{{ c.Subject }}</td>
                            </tr>
                            }
                        </table>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
    @if (currentPage === 2) {
    <div>
        <form [formGroup]="financialForm" (ngSubmit)="submitFinancial(financialForm)">
            <mat-card class="p-[30px] mt-0 mr-0 mb-[30px] ml-0 max-w-[100%]">
                <mat-radio-group formControlName="Ffaa" class="max-w-[600px] mb-[20px]">
                    <mat-label>Have you completed the Florida Financial Aid
                        Application (FFAA) for Bright Futures and other
                        scholarships?</mat-label>
                    <mat-radio-button [value]="true">Yes</mat-radio-button>
                    <mat-radio-button [value]="false">No</mat-radio-button>
                    @if (financialForm.get('Ffaa').hasError('required') && formSubmitted === true) {
                    <small class="radioError">response required</small>
                    }
                </mat-radio-group>
                <mat-radio-group formControlName="HavePrepaid" class="max-w-[600px] mb-[20px]">
                    <mat-label>Do you have Florida Pre-Paid?</mat-label>
                    <mat-radio-button [value]="true">Yes</mat-radio-button>
                    <mat-radio-button [value]="false">No</mat-radio-button>
                    @if (financialForm.get('HavePrepaid').hasError('required') && formSubmitted === true) {
                    <small class="radioError">response required</small>
                    }
                </mat-radio-group>
                <mat-form-field appearance="outline" class="max-w-[600px]">
                    <mat-label>FAFSA Student Aid Index</mat-label>
                    <input matInput formControlName="Sai" maxlength="10" />
                </mat-form-field>
                <mat-radio-group formControlName="NeedBased" class="max-w-[600px] flex flex-col gap-[10px] mb-[20px]">
                    <mat-radio-button [value]="true">I understand that if I do not email my FAFSA documentation showing my Student Aid Index to the PEFScholarships@polk-fl.net that I will not be eligible for any need based scholarships managed through Polk Education Foundation</mat-radio-button>
                    <mat-radio-button [value]="false">I do NOT want to be considered for need-based scholarships and recognize that I will NOT be eligible for any need-based scholarships, which donors designate financial need as a criteria for selection</mat-radio-button>
                    @if (financialForm.get('NeedBased').hasError('required') && formSubmitted === true) {
                    <small class="radioError">response required</small>
                    }
                </mat-radio-group>

                @if (formSubmitted === true && financialForm.valid === false) {
                <div class="summary my-[20px]">
                    <div>Form is not complete or has invalid responses</div>
                </div>
                }
                <div class="flex flex-wrap justify-around gap-[5px] w-full mt-[30px]">
                    <button mat-raised-button type="button" (click)="setPageNumber(1)">
                        Previous Section
                    </button>
                    @if (highestPage > 2) {
                    <button mat-raised-button type="button" (click)="setPageNumber(3)">
                        Next Section
                    </button>
                    }
                    <button mat-raised-button type="submit">
                        Save & Go To Next Section
                    </button>
                </div>
            </mat-card>
        </form>
    </div>
    }
    @if (currentPage === 3) {
    <div>
        <form [formGroup]="familyForm" (ngSubmit)="submitFamily(familyForm)">
            <mat-card class="p-[30px] mt-0 mr-0 mb-[30px] ml-0 max-w-[100%]">
                <mat-form-field appearance="outline" class="min-w-[400px]">
                    <mat-label>Mother's Name</mat-label>
                    <input matInput formControlName="MotherName" maxlength="45" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="min-w-[400px]">
                    <mat-label>Mother's Employer</mat-label>
                    <input matInput formControlName="MotherEmployer" maxlength="35" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="min-w-[400px]">
                    <mat-label>Father's Name</mat-label>
                    <input matInput formControlName="FatherName" maxlength="45" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="min-w-[400px]">
                    <mat-label>Father's Employer</mat-label>
                    <input matInput formControlName="FatherEmployer" maxlength="35" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="min-w-[400px]">
                    <mat-label>How many people living in your home</mat-label>
                    <input matInput formControlName="HouseholdSize" maxlength="2" />
                    @if (familyForm.get('HouseholdSize').hasError('validateNumber')) {
                    <mat-error>response must be a number</mat-error>
                    }
                </mat-form-field>
                <mat-form-field appearance="outline" class="min-w-[400px]">
                    <mat-label>How many other family members attend college</mat-label>
                    <input matInput formControlName="FamilyInCollegeNumber" maxlength="2" />
                    @if (familyForm.get('FamilyInCollegeNumber').hasError('validateNumber')) {
                    <mat-error>response must be a number</mat-error>
                    }
                </mat-form-field>

                @if (formSubmitted === true && familyForm.valid === false) {
                <div class="summary my-[20px]">
                    <div>Form is not complete or has invalid responses</div>
                </div>
                }
                <div class="flex flex-wrap justify-around gap-[5px] w-full mt-[30px]">
                    <button mat-raised-button type="button" (click)="setPageNumber(2)">
                        Previous Section
                    </button>
                    @if (highestPage > 3) {
                    <button mat-raised-button type="button" (click)="setPageNumber(4)">
                        Next Section
                    </button>
                    }
                    <button mat-raised-button type="submit">
                        Save & Go To Next Section
                    </button>
                </div>
            </mat-card>
        </form>
    </div>
    }
    <div [hidden]="currentPage !== 4">
        <form [formGroup]="collegeForm" (ngSubmit)="submitCollege(collegeForm)">
            <mat-card class="p-[30px] mt-0 mr-0 mb-[30px] ml-0 max-w-[100%]">
                <mat-form-field appearance="outline">
                    <mat-label>Intended College/University/Trade School</mat-label>
                    <input matInput formControlName="SelectedInstitution" maxlength="45" />
                    @if (collegeForm.get('SelectedInstitution').hasError('required')) {
                    <mat-error>response required</mat-error>
                    }
                </mat-form-field>
                <mat-radio-group formControlName="Accepted" class=" mb-[20px]">
                    <mat-label>Have you been accepted to this institution?</mat-label>
                    <mat-radio-button [value]="'YES'">Yes</mat-radio-button>
                    <mat-radio-button [value]="'NO'">No</mat-radio-button>
                    <mat-radio-button [value]="'PND'">Pending</mat-radio-button>
                    @if (collegeForm.get('Accepted').hasError('required') && formSubmitted === true) {
                    <small class="radioError">response required</small>
                    }
                </mat-radio-group>
                <mat-form-field appearance="outline">
                    <mat-label>Intended College Major/Trade Program</mat-label>
                    <input matInput formControlName="IntendedMajor" maxlength="50" />
                    @if (collegeForm.get('IntendedMajor').hasError('required')) {
                    <mat-error>response required</mat-error>
                    }
                </mat-form-field>
                <div class="note">
                    <strong>Note:</strong>
                    @if (smallScreen === false) {
                    <span>There are entry areas in each of the four tabs below. </span>
                    }
                    If a question is not applicable to you, type "N/A"
                </div>
                @if (smallScreen === false) {
                <div>
                    <div class="min-w-[550px]">
                        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" dynamicHeight mat-stretch-tabs="true" disablePagination="true" class="my-[20px]">
                            <mat-tab>
                                <ng-template mat-tab-label>
                                    <p [style.color]="
                                            collegeForm
                                                .get('WhyMajor')
                                                .hasError('required') &&
                                            collegeForm.get('WhyMajor').touched
                                                ? 'red'
                                                : null
                                        ">
                                        Major/Program
                                    </p>
                                </ng-template>
                                <div class="p-[20px] border-[5px] border-solid border-sky-200">
                                    <mat-form-field class="w-full" appearance="outline">
                                        <mat-label>What was the reason you chose this major/program?</mat-label>
                                        <textarea matInput formControlName="WhyMajor" required cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="8" maxlength="2000" #major></textarea>
                                        <mat-hint align="end">{{ major.value.length }}/2000</mat-hint>
                                        @if (collegeForm.get('WhyMajor').hasError('required')) {
                                        <mat-error>response required</mat-error>
                                        }
                                    </mat-form-field>
                                </div>
                            </mat-tab>
                            <mat-tab>
                                <ng-template mat-tab-label>
                                    <p [style.color]="
                                            collegeForm
                                                .get('EmploymentHistory')
                                                .hasError('required') &&
                                            collegeForm.get('EmploymentHistory').touched
                                                ? 'red'
                                                : null
                                        ">
                                        Employment
                                    </p>
                                </ng-template>
                                <div class="p-[20px] border-[5px] border-solid border-sky-200">
                                    <mat-form-field class="w-full" appearance="outline">
                                        <mat-label>List your employment history (current and
                                            past employers)</mat-label>
                                        <textarea matInput formControlName="EmploymentHistory" required cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="8" maxlength="2000" #jobs></textarea>
                                        <mat-hint align="end">{{ jobs.value.length }}/2000</mat-hint>
                                        @if (collegeForm.get('EmploymentHistory').hasError('required')) {
                                        <mat-error>response required</mat-error>
                                        }
                                    </mat-form-field>
                                </div>
                            </mat-tab>
                            <mat-tab>
                                <ng-template mat-tab-label>
                                    <p [style.color]="
                                            collegeForm
                                                .get('VolunteerDescription')
                                                .hasError('required') &&
                                            collegeForm.get('VolunteerDescription')
                                                .touched
                                                ? 'red'
                                                : null
                                        ">
                                        Community Service
                                    </p>
                                </ng-template>
                                <div class="p-[20px] border-[5px] border-solid border-sky-200">
                                    <mat-form-field class="w-full" appearance="outline">
                                        <mat-label>List the types of community service you
                                            have done</mat-label>
                                        <textarea matInput formControlName="VolunteerDescription" required cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="8" maxlength="2000" #vol></textarea>
                                        <mat-hint align="end">{{ vol.value.length }}/2000</mat-hint>
                                        @if (collegeForm.get('VolunteerDescription').hasError('required')) {
                                        <mat-error>response required</mat-error>
                                        }
                                    </mat-form-field>
                                </div>
                            </mat-tab>
                            <mat-tab>
                                <ng-template mat-tab-label>
                                    <p [style.color]="
                                            collegeForm
                                                .get('OtherAwards')
                                                .hasError('required') &&
                                            collegeForm.get('OtherAwards').touched
                                                ? 'red'
                                                : null
                                        ">
                                        Other Scholarships
                                    </p>
                                </ng-template>
                                <div class="p-[20px] border-[5px] border-solid border-sky-200">
                                    <mat-form-field class="w-full" appearance="outline">
                                        <mat-label>Other than those on this application, list
                                            all other scholarships which you have
                                            applied</mat-label>
                                        <mat-hint>Include the scholarship amount and status
                                            of the scholarship.
                                            (applied/denied/awarded)</mat-hint>
                                        <textarea matInput formControlName="OtherAwards" required cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="8" maxlength="2000" #other></textarea>
                                        <mat-hint align="end">{{ other.value.length }}/2000</mat-hint>
                                        @if (collegeForm.get('OtherAwards').hasError('required')) {
                                        <mat-error>response required</mat-error>
                                        }
                                    </mat-form-field>
                                </div>
                            </mat-tab>
                        </mat-tab-group>
                    </div>
                </div>
                }

                @if (smallScreen === true) {
                <div class="my-[20px]">
                    <label>What was the reason you chose this major?</label>
                    <mat-form-field class="w-full mt-[10px]" appearance="outline">
                        <mat-label>response:</mat-label>
                        <textarea matInput formControlName="WhyMajor" required cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="8" maxlength="2000" #major></textarea>
                        <mat-hint align="end">{{ major.value.length }}/2000</mat-hint>
                        @if (collegeForm.get('WhyMajor').hasError('required')) {
                        <mat-error>response required</mat-error>
                        }
                    </mat-form-field>
                    <label>List your employment history (current and past employers)</label>
                    <mat-form-field class="w-full mt-[10px]" appearance="outline">
                        <mat-label>response:</mat-label>
                        <textarea matInput formControlName="EmploymentHistory" required cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="8" maxlength="2000" #jobs></textarea>
                        <mat-hint align="end">{{ jobs.value.length }}/2000</mat-hint>
                        @if (collegeForm.get('EmploymentHistory').hasError('required')) {
                        <mat-error>response required</mat-error>
                        }
                    </mat-form-field>
                    <label>List the types of community service you have done</label>
                    <mat-form-field class="w-full mt-[10px]" appearance="outline">
                        <mat-label>response:</mat-label>
                        <textarea matInput formControlName="VolunteerDescription" required cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="8" maxlength="2000" #vol></textarea>
                        <mat-hint align="end">{{ vol.value.length }}/2000</mat-hint>
                        @if (collegeForm.get('VolunteerDescription').hasError('required')) {
                        <mat-error>response required</mat-error>
                        }
                    </mat-form-field>
                    <label>Other than those on this application,
                        list all other scholarships which you have applied
                    </label>
                    <mat-form-field class="w-full mt-[10px]" appearance="outline">
                        <mat-label>response:</mat-label>
                        <mat-hint>Include the scholarship amount and status
                            of the scholarship.
                            (applied/denied/awarded)</mat-hint>
                        <textarea matInput formControlName="OtherAwards" required cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="8" maxlength="2000" #other></textarea>
                        <mat-hint align="end">{{ other.value.length }}/2000</mat-hint>
                        @if (collegeForm.get('OtherAwards').hasError('required')) {
                        <mat-error>response required</mat-error>
                        }
                    </mat-form-field>
                </div>
                }

                @if (formSubmitted === true && collegeForm.valid === false) {
                <div class="summary my-[20px]">
                    <div>Form is not complete or has invalid responses</div>
                </div>
                }
                <div class="flex flex-wrap justify-around gap-[5px] w-full mt-[30px]">
                    <button mat-raised-button type="button" (click)="setPageNumber(3)">
                        Previous Section
                    </button>
                    @if (highestPage > 4) {
                    <button mat-raised-button type="button" (click)="setPageNumber(5)">
                        Next Section
                    </button>
                    }
                    <button mat-raised-button type="submit">
                        Save & Go To Next Section
                    </button>
                </div>
            </mat-card>
        </form>
    </div>
    @if (currentPage === 5) {
    <div>
        <form [formGroup]="essayForm" (ngSubmit)="submitEssay(essayForm)">
            <mat-card class="p-[30px] mt-0 mr-0 mb-[30px] ml-0 max-w-[100%]">
                <p class="w-full">
                    Use this essay to provide information requested by each
                    individual scholarship, Personal financial need information,
                    college and career plans, and any other information you feel
                    would help in the selection process. Things like medical
                    problems, divorce, and special family situations are all
                    considered when awarding scholarships.
                    <strong>
                        Many scholarships will be chosen solely on the
                        information contained in this essay. So be specific and
                        state your need clearly.
                    </strong>
                    Honors, awards, clubs, volunteer time, leadership roles, and
                    extra curricular activities may be included in your essay;
                    however, do not send certificates, resumes, or other
                    documents in your application submission, as they are
                    discarded and not considered.
                </p>
                <p class="w-full">
                    <strong>
                        You are advised to type your essay in a Word document
                        first to spell check, and check character count. (7000
                        characters including spaces) This will be approximately
                        two pages using one inch margins and a 12pt font, single
                        spaced.
                    </strong>
                </p>
                <mat-form-field class="w-full" appearance="outline">
                    <mat-label>Essay</mat-label>
                    <textarea matInput formControlName="Essay" required cdkTextareaAutosize cdkAutosizeMinRows="10" cdkAutosizeMaxRows="20" minlength="50" maxlength="7000" #essay></textarea>
                    <mat-hint align="end">{{ essay.value.length }}/7000</mat-hint>
                    @if (essayForm.get('Essay').hasError('minlength')) {
                    <mat-error>50 char min length</mat-error>
                    }
                    @if (essayForm.get('Essay').hasError('required')) {
                    <mat-error>response required</mat-error>
                    }
                </mat-form-field>

                <mat-radio-group formControlName="EssayAI" class=" mb-[20px]">
                    <mat-label>
                        Did you use an AI platform to enhance your general essay?
                        Your answer will not disqualify you from any scholarship.
                    </mat-label>
                    <mat-radio-button [value]="true">Yes</mat-radio-button>
                    <mat-radio-button [value]="false">No</mat-radio-button>
                    @if (essayForm.get('EssayAI').hasError('required') && formSubmitted === true) {
                    <small class="radioError">response required</small>
                    }
                </mat-radio-group>

                <mat-form-field appearance="outline">
                    <mat-label>How did you utilize AI to enhance your essay?</mat-label>
                    <input matInput formControlName="AiHow" maxlength="100" />
                    @if (essayForm.get('AiHow').hasError('required')) {
                    <mat-error>response required</mat-error>
                    }
                </mat-form-field>

                @if (formSubmitted === true && essayForm.valid === false) {
                <div class="summary my-[20px]">
                    <div>Form is not complete or has invalid responses</div>
                </div>
                }
                <div class="flex flex-wrap justify-around gap-[5px] w-full mt-[30px]">
                    <button mat-raised-button type="button" (click)="setPageNumber(4)">
                        Previous Section
                    </button>
                    @if (highestPage > 5) {
                    <button mat-raised-button type="button" (click)="setPageNumber(6)">
                        Next Section
                    </button>
                    }
                    <button mat-raised-button type="submit">
                        Save & Go To Next Section
                    </button>
                </div>
            </mat-card>
        </form>
    </div>
    }
    @if (currentPage === 6) {
    <div>
        <form [formGroup]="selectionForm" (ngSubmit)="submitSelection(selectionForm)">
            <ng-container formArrayName="Scholarships">
                <div class="scrollbar" [ngClass]="{ smallScreenScroll: smallScreen }">
                    @for (sch of scholarshipArray.controls; track sch.value.ScholarshipID; let i = $index) {
                    <mat-card [formGroupName]="i" [ngClass]="{ smallScreenCards: smallScreen }" [class.invalid]="sch.invalid && formSubmitted === true" class="p-[30px] mt-0 mr-0 mb-[30px] ml-0 max-w-[100%]">
                        <mat-checkbox formControlName="Selected">
                            <strong>{{sch.value.ScholarshipName}}</strong>
                        </mat-checkbox>
                        <p>{{ sch.value.ScholarshipDescription }}</p>

                        @if (sch.value.AdditionalQuestion != null) {
                        <div>
                            <span class="text">Additional Question</span>
                        </div>
                        <div class="flex flex-col">
                            @if (sch.value.AqHaveYesNo === true) {
                            <mat-radio-group formControlName="AdditionalQuestionYesNoResponse" class="flex justify-start gap-[10px] mb-[20px]">
                                <mat-radio-button [value]="true" (click)="$event.preventDefault(); 
                                    resetRadio(true, i)" matTooltip="Click again to clear value" #trueRadio [matTooltipDisabled]="trueRadio.checked !== true">
                                    Yes
                                </mat-radio-button>
                                <mat-radio-button [value]="false" (click)="$event.preventDefault(); 
                                    resetRadio(false, i)" matTooltip="Click again to clear value" #falseRadio [matTooltipDisabled]="falseRadio.checked !== true">
                                    No
                                </mat-radio-button>
                                <mat-label>{{sch.value.AdditionalQuestion}}</mat-label>
                            </mat-radio-group>
                            @if (sch.get('AdditionalQuestionYesNoResponse').hasError('required') && formSubmitted === true) {
                            @if (sch.get('AqYesRequired').value === true) {
                            <small class="radioError">yes is required</small>
                            }
                            @else {
                            <small class="radioError">response required</small>
                            }
                            }
                            }
                            @else {
                            <div>{{ sch.value.AdditionalQuestion }}</div>
                            }
                            @if (sch.value.AqHaveText === true) {
                            <mat-form-field class="w-full">
                                <input matInput formControlName="AdditionalQuestionTextResponse" maxlength="7000" />
                                @if (sch.get('AdditionalQuestionTextResponse').hasError('required')) {
                                <mat-error>response required</mat-error>
                                }
                            </mat-form-field>
                            }
                        </div>
                        }

                        @if (sch.value.EmployeeNameLabel != null) {
                        <div>
                            <div class="text">
                                {{ sch.value.EmployeeNameLabel }}
                            </div>
                            <mat-form-field class="w-full">
                                <input matInput formControlName="EmployeeNameResponse" maxlength="100" />
                                @if (sch.get('EmployeeNameResponse').hasError('required')) {
                                <mat-error>response required</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        }

                        @if (sch.value.EmployeeLocationLabel != null) {
                        <div>
                            <div class="text">
                                {{ sch.value.EmployeeLocationLabel }}
                            </div>
                            <mat-form-field class="w-full">
                                <input matInput formControlName="EmployeeLocationResponse" maxlength="100" />
                                @if (sch.get('EmployeeLocationResponse').hasError('required')) {
                                <mat-error>response required</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        }

                        @if (sch.value.EmployeeSSNLabel != null) {
                        <div>
                            <div class="text">
                                {{ sch.value.EmployeeSSNLabel }}
                            </div>
                            <mat-form-field class="w-full">
                                <input matInput formControlName="EmployeeSSNResponse" maxlength="11" />
                                @if (sch.get('EmployeeSSNResponse').hasError('required')) {
                                <mat-error>response required</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        }

                        @if (sch.value.StoreLocationNumberLabel != null) {
                        <div>
                            <div class="text">
                                {{ sch.value.StoreLocationNumberLabel }}
                            </div>
                            <mat-form-field class="w-full">
                                <input matInput formControlName="StoreLocationNumberResponse" maxlength="100" />
                                @if (sch.get('StoreLocationNumberResponse').hasError('required')) {
                                <mat-error>response required</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        }

                        @if (sch.value.AccountNameLabel != null) {
                        <div>
                            <div class="text">
                                {{ sch.value.AccountNameLabel }}
                            </div>
                            <mat-form-field class="w-full">
                                <input matInput formControlName="AccountNameResponse" maxlength="100" />
                                @if (sch.get('AccountNameResponse').hasError('required')) {
                                <mat-error>response required</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        }

                        @if (sch.value.AccountNumberLabel != null) {
                        <div>
                            <div class="text">
                                {{ sch.value.AccountNumberLabel }}
                            </div>
                            <mat-form-field class="w-full">
                                <input matInput formControlName="AccountNumberResponse" maxlength="100" />
                                @if (sch.get('AccountNumberResponse').hasError('required')) {
                                <mat-error>response required</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        }

                        @if (sch.value.ParentNameLabel != null) {
                        <div>
                            <div class="text">
                                {{ sch.value.ParentNameLabel }}
                            </div>
                            <mat-form-field class="w-full">
                                <input matInput formControlName="ParentNameResponse" maxlength="100" />
                                @if (sch.get('ParentNameResponse').hasError('required')) {
                                <mat-error>response required</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        }

                        @if (sch.value.ParentSSNLabel != null) {
                        <div>
                            <div class="text">
                                {{ sch.value.ParentSSNLabel }}
                            </div>
                            <mat-form-field class="w-full">
                                <input matInput formControlName="ParentSSNResponse" maxlength="11" />
                                @if (sch.get('ParentSSNResponse').hasError('required')) {
                                <mat-error>response required</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        }

                        @if (sch.value.ParentOrganizationLabel != null) {
                        <div>
                            <div class="text">
                                {{ sch.value.ParentOrganizationLabel }}
                            </div>
                            <mat-form-field class="w-full">
                                <input matInput formControlName="ParentOrganizationResponse" maxlength="100" />
                                @if (sch.get('ParentOrganizationResponse').hasError('required')) {
                                <mat-error>response required</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        }

                        @if (sch.value.ParentDepartmentLabel != null) {
                        <div>
                            <div class="text">
                                {{ sch.value.ParentDepartmentLabel }}
                            </div>
                            <mat-form-field class="w-full">
                                <input matInput formControlName="ParentDepartmentResponse" maxlength="100" />
                                @if (sch.get('ParentDepartmentResponse').hasError('required')) {
                                <mat-error>response required</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        }

                        @if (sch.value.ScholarshipEssayLabel != null) {
                        <div>
                            <div class="text">
                                {{ sch.value.ScholarshipEssayLabel }}
                            </div>
                            <mat-form-field class="w-full">
                                <textarea matInput formControlName="ScholarshipEssayResponse" cdkTextareaAutosize cdkAutosizeMinRows="5" cdkAutosizeMaxRows="10" maxlength="8000"></textarea>
                                @if (sch.get('ScholarshipEssayResponse').hasError('required')) {
                                <mat-error>response required</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        }

                        @if (sch.value.ScholarshipEssay2Label != null) {
                        <div>
                            <div class="text">
                                {{ sch.value.ScholarshipEssay2Label }}
                            </div>
                            <mat-form-field class="w-full">
                                <textarea matInput formControlName="ScholarshipEssay2Response" cdkTextareaAutosize cdkAutosizeMinRows="5" cdkAutosizeMaxRows="10" maxlength="8000"></textarea>
                                @if (sch.get('ScholarshipEssay2Response').hasError('required')) {
                                <mat-error>response required</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        }
                    </mat-card>
                    }
                </div>
            </ng-container>

            <div class="flex flex-wrap justify-around gap-[5px] w-full mt-[30px]">
                <button mat-raised-button type="button" (click)="setPageNumber(5)">
                    Previous Section
                </button>
                <button mat-icon-button type="button" (click)="openSelectionDialog()" matTooltip="Show info message for Scholarship Selection section">
                    <mat-icon [class.highlighted]="highlighted">info_outline</mat-icon>
                </button>
                @if (highestPage > 6) {
                <button mat-raised-button type="button" (click)="setPageNumber(7)">
                    Next Section
                </button>
                }
                <button mat-raised-button type="submit">
                    Save & Go To Next Section
                </button>
            </div>
        </form>
    </div>
    }
    @if (currentPage === 7) {
    @if (xsScreen === true) {
    <p class="text-red-500">It is recommended to hold your device in landscape mode</p>
    }
    <div class="my-[20px]">
        <mat-card class="p-[30px] mt-0 mr-0 mb-[30px] ml-0 max-w-[100%]">
            <mat-card-header>
                <mat-card-title>Student Signature</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>Please sign here to authorize and confirm all information in the application is correct</p>
                <app-signature-collector [inputSignature]="studentSignature()" type="STUDENT" (outputSignature)="submitSignature($event)" />
            </mat-card-content>
        </mat-card>
        <mat-card class="p-[30px] mt-0 mr-0 mb-[30px] ml-0 max-w-[100%]">
            <mat-card-header>
                <mat-card-title>Parent/Guardian Signature</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>Please sign here to authorize and confirm all information in the application is correct</p>
                <app-signature-collector [inputSignature]="parentSignature()" type="PARENT" (outputSignature)="submitSignature($event)" />
            </mat-card-content>
        </mat-card>
        <div class="flex flex-wrap justify-around gap-[5px] w-full mt-[30px]">
            <button mat-raised-button type="button" (click)="setPageNumber(6)">
                Previous Section
            </button>
            <button mat-flat-button type="button" (click)="postApplication()" [disabled]="parentSignature() == null || studentSignature() == null">
                Finalize & Submit Application
            </button>
        </div>
    </div>
    }
    }
</div>